<template>
    <div v-if="isShow && list && list.length > 0" class="list">
        <div
         v-for="(item, index) in list"
         @click="()=> select(index)"
         :key="item.name"
         :class="['item', index === selectIndex && 'active']">
            {{item.name}}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            require: true
        }
    },
    data() {
        return {
            selectIndex: 0,
            isShow: false
        }
    },
    methods: {
        select(index) {
            this.selectIndex = index;
            this.$emit("select", {index});
            this.hide()
        },
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .list {
        position: absolute;
        bottom: 100%;
        left: 0;
        width: 100%;
        border: solid 1px #2ac1ff;
        background-color: #002c5552;
        .item {
            width: 100%;
            height: 26px;
            text-align: center;
            font-size: 14px;
            color: #a7aeb0;
            line-height: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            box-sizing: border-box;
        }
        .active {
            color: #ffffff;
            border-left: 4px solid #00c6ff;
            background-image: linear-gradient(to right, rgba(11,58,119,0.68), rgba(12,55,109,0.34), rgba(12,51,100,0), rgba(12,47,89,0));
        }
    }
</style>